import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";

export default function ServiceCard({icon: Icon, name, desc, link, setType, setDay, setTime}) {
    const categories = [
        "Housing",
        "Food",
        "Clothing",
        "Health",
        "Finances",
        "Family Resources",
        "Education",
    ];
    const correspondingTypes = [
        "Shelter",
        "Food Pantry",
        "Clothing",
        "Medical",
        "Financial",
        "Family Help",
        "Education",
    ];

    return (
        <div className="flex flex-col shadow-md p-5 rounded-lg w-full sm:w-fit text-[#2e5c83] gap-3 max-w-[300px]">
            {Icon && (
                <Icon style={{ fontSize: "50px" }} className="text-black" />
            )}
            <h3 className="text-lg font-bold">{name}</h3>
            <p className="flex-1">{desc}</p>
            <Link
                to={link}
                onClick={() => {
                    setType(correspondingTypes[categories.indexOf(name)]);
                    setDay("All");
                    setTime(null);
                }}
            >
                <div className="group flex flex-row gap-1 items-center font-semibold mt-auto hover:opacity-80 transition-all duration-200 ease-in-out text-[#2e5c83]">
                    Learn more
                    <ArrowForwardIcon className="group-hover:animate-bounce-x" />
                </div>
            </Link>
        </div>
    );
}
